<template>
  <q-form ref="editForm">
    <!-- 기본정보 -->
    <c-card title="LBLBASEINFO" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline>
          <!-- 저장 -->
          <c-btn
            v-if="!disabled"
            :url="updateUrl"
            :isSubmit="isSave"
            :param="tabParam"
            mappingType="PUT"
            label="LBLSAVE"
            icon="save"
            @beforeAction="saveAccident"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
          <!-- 보고일 -->
          <c-datepicker
            :editable="editable"
            :disabled="disabled"
            label="LBL0002380"
            name="reportDate"
            v-model="tabParam.reportDate"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
          <!-- 발생원인 -->
          <c-text
            :editable="editable"
            :disabled="disabled"
            label="LBL0002381"
            name="occurrenceCause"
            v-model="tabParam.occurrenceCause">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <!-- 사고피해 -->
          <c-textarea
            :editable="editable"
            :disabled="disabled"
            :rows="2"
            label="LBL0002382"
            name="accidentDamageHistory"
            v-model="tabParam.accidentDamageHistory">
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <!-- 비상조치사항 -->
          <c-textarea
            :editable="editable"
            :disabled="disabled"
            label="LBL0002383"
            :rows="2"
            name="emergencyMeasures"
            v-model="tabParam.emergencyMeasures">
          </c-textarea>
        </div>
      </template>
    </c-card>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <!-- 사고자 인적사항 목록 -->
      <c-table
        ref="table"
        title="LBL0002339"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="tabParam.accidentVictimModelList"
        :filtering="false"
        :columnSetting="false"
        :checkClickFlag="false"
        :usePaging="false"
        :editable="editable && !disabled"
        selection="multiple"
        rowKey="victimId"
        @table-data-change= "tableDataChange"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline> 
            <!-- 내부직원 추가 -->
              <c-btn v-if="editable && !disabled" :showLoading="false" label="LBL0002347" icon="add" @btnClicked="add" />
            <!-- 외부직원 추가 -->
              <c-btn v-if="editable && !disabled" :showLoading="false" label="LBL0002348" icon="add" @btnClicked="addRow" />
            <!-- 제외 -->
            <c-btn v-if="editable && !disabled && tabParam.accidentVictimModelList.length > 0" :showLoading="false"  label="LBLEXCEPT" icon="remove" @btnClicked="remove" />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name ==='victimName'">
            <c-text-column
              v-if="props.row['insideOutsideTypeCd'] === 'N'"
              :editable="editable"
              :props="props"
              :col="col"
              :disabled="disabled"
              v-model="props.row['victimName']"
              @datachange="datachange(props)"
            />
            <span v-else>
              {{props.row['victimName']}}
            </span>
          </template>
          <template v-if="col.name ==='birthDate'">
            <c-datepicker
              v-if="props.row['insideOutsideTypeCd'] === 'N'"
              class="tableDatepicker"
              :editable="editable"
              :disabled="disabled"
              v-model="props.row['birthDate']"
              @datachange="datachange(props)"
            />
            <span v-else>
              {{props.row['birthDate']}}
            </span>
          </template>
          <template v-if="col.name ==='career'">
            <c-text-column
              v-if="props.row['insideOutsideTypeCd'] === 'N'"
              :editable="editable"
              :props="props"
              :col="col"
              :disabled="disabled"
              v-model="props.row['career']"
              @datachange="datachange(props)"
            />
            <span v-else>
              {{props.row['career']}}
            </span>
          </template>
        </template>
      </c-table>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <!-- 물적피해 -->
        <c-card title="LBL0002384" class="cardClassDetailForm">
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <!-- 손실내역 -->
              <c-text
                :editable="editable"
                :disabled="disabled"
                label="LBL0002385"
                name="materialLossHistory"
                v-model="tabParam.materialLossHistory">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <!-- 손실금액 -->
              <!-- 원 -->
              <c-text
                :suffix="$label('LBL00001543')"
                :editable="editable"
                :disabled="disabled"
                type="number"
                label="LBL0002386"
                name="materialLossAmount"
                v-model="tabParam.materialLossAmount">
              </c-text>
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <!-- 환경피해 -->
        <c-card title="LBL0002387" class="cardClassDetailForm">
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <!-- 누출정보 -->
              <c-text
                :editable="editable"
                :disabled="disabled"
                :range="true"
                label="LBL0002388"
                name="enviromentLeakInformation"
                v-model="tabParam.enviromentLeakInformation">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <!-- 영향내역 -->
              <c-text
                :editable="editable"
                :disabled="disabled"
                :range="true"
                label="LBL0002389"
                name="enviromentImpactHistory"
                v-model="tabParam.enviromentImpactHistory">
              </c-text>
            </div>
          </template>
        </c-card>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>

import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import { uid } from 'quasar'
export default {
  name: 'process-accident-reception-result',

  props: {
    popupParam: {
      type: Object,
      default: () => ({
        stepCd: '',
      }),
    },
    tabParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        investigationFlag: '',
        investigationStartDate: '',
        investigationEndDate: '',
        investigationPlan: '',
        reportDate: '',
        occurrenceCause: '',
        accidentDamageHistory: '',
        emergencyMeasures: '',
        materialLossHistory: '',
        materialLossAmount: '',
        enviromentLeakInformation: '',
        enviromentImpactHistory: '',
        accidentStatusCd: '',
        deleteAccidentVictimModelList: [],
        accidentVictimModelList: [],
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'victimName',
            field: 'victimName',
            // 이름
            label: 'LBLNAME',
            style: 'width:10%',
            type: 'custom',
            align: 'center',
            sortable: false
          },
          {
            name: 'birthDate',
            field: 'birthDate',
            // 생년월일
            label: 'LBL0002341',
            style: 'width:10%',
            align: 'center',
            type: 'custom',
            sortable: false
          },
          {
            name: 'career',
            field: 'career',
            // 직급
            label: 'LBL0002342',
            style: 'width:10%',
            align: 'center',
            type: 'custom',
            sortable: false
          },
          {
            setHeader: true,
            name: 'interspersedFlag',
            field: 'interspersedFlag',
            // 산재여부
            label: 'LBL0002390',
            align: 'center',
            style: 'width:10%',
            type: 'select',
            comboItems: [
              { code: 'Y', codeName: '산재' },
              { code: 'N', codeName: '해당없음' },
            ],
            sortable: false,
          },
          // {
          //   name: 'insideOutsideTypeName',
          //   field: 'insideOutsideTypeName',
          //   label: '내/외부',
          //   align: 'center',
          //   style: 'width:50px',
          //   sortable: false,
          // },
          {
            name: 'degreeDamage',
            field: 'degreeDamage',
            // 피해상해정도
            label: 'LBL0002343',
            style: 'width:20%',
            type: "textarea",
            align: 'left',
            sortable: false
          },
          {
            name: 'expectTreatmentDate',
            field: 'expectTreatmentDate',
            // 예상치료기간
            label: 'LBL0002344',
            type: "date",
            range: true,
            style: 'width:20%',
            align: 'center',
            sortable: false
          },
          {
            name: 'actionMatters',
            field: 'actionMatters',
            // 조치사항
            label: 'LBL0002345',
            style: 'width:20%',
            type: "textarea",
            align: 'left',
            sortable: false
          },
        ],
        data: [],
        height: '300px'
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      editable: true,
      searchUrl: '',
      updateUrl: 'transactionConfig.sop.iim.accident.process.investigation.update.url',
      isSave: false,
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.popupParam.stepCd) && (this.popupParam.stepCd === 'ISPC000005') || this.tabParam.investigationFlag === 'N' 
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      this.updateUrl = transactionConfig.sop.iim.accident.process.investigation.update.result.url;
      this.getUrl = selectConfig.sop.iim.accident.process.get.url;
      // list setting
    },
    add() {
      this.popupOptions.title = 'LBL0002346'; // 사고자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.tabParam.accidentVictimModelList, {
            victimUserId: _item.userId,
          });
          if (index === -1) {
            this.tabParam.accidentVictimModelList.splice(0, 0, {
              iimAccidentId: this.tabParam.iimAccidentId,
              victimId: uid(),
              victimUserId: _item.userId,
              victimName: _item.userName,
              birthDate: _item.birthDate,
              insideOutsideTypeName: '내부',
              insideOutsideTypeCd: 'Y',
              interspersedFlag: null,
              age: '',
              career: _item.spotName,
              degreeDamage: '',
              expectTreatmentDate: [],
              expectTreatmentStartDate: '',
              expectTreatmentEndDate: '',
              actionMatters: '',
              editFlag: 'C'
            })
          }
        })
      }
    },
    addRow() {
      this.tabParam.accidentVictimModelList.splice(0, 0, {
        iimAccidentId: this.tabParam.iimAccidentId,
        victimId: uid(),
        victimName: '',
        birthDate: '',
        insideOutsideTypeName: '내부',
        insideOutsideTypeCd: 'N',
        age: '',
        career: '',
        degreeDamage: '',
        expectTreatmentDate: [],
        expectTreatmentStartDate: '',
        expectTreatmentEndDate: '',
        interspersedFlag: null,
        actionMatters: '',
        editFlag: 'C'
      })
    },
    remove() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.tabParam.deleteAccidentVictimModelList) {
              this.tabParam.deleteAccidentVictimModelList = []
          }
          if (this.$_.findIndex(this.tabParam.deleteAccidentVictimModelList, { victimId: item.victimId }) === -1
          && item.editFlag !== 'C') {
            this.tabParam.deleteAccidentVictimModelList.push(item)
          }
          this.tabParam.accidentVictimModelList = this.$_.reject(this.tabParam.accidentVictimModelList, { victimId: item.victimId })
        })
      }
    },
    saveAccident() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.tabParam.regUserId = this.$store.getters.user.userId
              this.tabParam.chgUserId = this.$store.getters.user.userId
              
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail')
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    tableDataChange(props, col) {
      if (col.name === 'expectTreatmentDate') {
        if (props.row.expectTreatmentDate && props.row.expectTreatmentDate.length > 0) {
          this.$set(props.row, 'expectTreatmentStartDate', props.row.expectTreatmentDate[0])
          this.$set(props.row, 'expectTreatmentEndDate', props.row.expectTreatmentDate[1])
        } else {
          this.$set(props.row, 'expectTreatmentStartDate', '')
          this.$set(props.row, 'expectTreatmentEndDate', '')
        }
      }
    }
  }
};
</script>
